import { Instagram, Facebook, Youtube, Mail, ArrowUp } from "lucide-react";

const socials = [
  { icon: Instagram, href: "https://www.instagram.com/zlapkodnatury/", label: "Instagram" },
  { icon: Facebook, href: "https://facebook.com", label: "Facebook" },
  { icon: Youtube, href: "https://youtube.com", label: "YouTube" },
];

const nav = [
  { label: "O projekcie", href: "#o-projekcie" },
  { label: "Kategorie", href: "#kategorie" },
  { label: "Darmowe materiały", href: "#materialy" },
  { label: "Dlaczego warto", href: "#dlaczego" },
];

export default function Footer() {
  const scrollTo = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-beige border-t border-line" data-testid="footer">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-forest text-gold font-outfit text-lg font-semibold">⟁</span>
            <span className="font-outfit text-lg font-semibold tracking-tight text-ink">Złap Kod Natury</span>
          </div>
          <p className="mt-5 max-w-sm font-manrope text-sm text-ink-soft leading-relaxed">
            Kreatywne pomysły na lekcje przyrody i geografii, escape roomy edukacyjne oraz AI
            w pracy nauczyciela. Łam schematy — zaciekaw uczniów.
          </p>
          <div className="mt-6 flex items-center gap-3">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-line bg-surface text-ink-soft shadow-clay hover:text-forest hover:border-gold transition-colors duration-300"
                data-testid={`footer-social-${s.label.toLowerCase()}`}
              >
                <s.icon className="h-4.5 w-4.5" strokeWidth={1.75} />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-outfit text-sm uppercase tracking-[0.15em] text-gold">Nawigacja</h4>
          <ul className="mt-5 space-y-3">
            {nav.map((n) => (
              <li key={n.href}>
                <a href={n.href} onClick={(e) => scrollTo(e, n.href)} className="font-manrope text-sm text-ink-soft hover:text-forest transition-colors" data-testid={`footer-nav-${n.href.slice(1)}`}>
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-outfit text-sm uppercase tracking-[0.15em] text-gold">Kontakt</h4>
          <a href="mailto:aneta.jerzewska@gmail.com" className="mt-5 inline-flex items-center gap-2 font-manrope text-sm text-ink-soft hover:text-forest transition-colors" data-testid="footer-email">
            <Mail className="h-4 w-4" strokeWidth={1.75} /> aneta.jerzewska@gmail.com
          </a>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="mt-6 flex items-center gap-2 font-outfit text-sm text-forest border-b border-gold pb-0.5 hover:gap-3 transition-all"
            data-testid="footer-back-to-top"
          >
            Wróć na górę <ArrowUp className="h-4 w-4" strokeWidth={1.75} />
          </button>
        </div>
      </div>

      <div className="border-t border-line">
        <div className="w-full max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-manrope text-xs text-ink-soft">© {new Date().getFullYear()} Złap Kod Natury. Wszelkie prawa zastrzeżone.</p>
          <a href="/admin" className="font-manrope text-xs text-ink-soft/60 hover:text-forest transition-colors" data-testid="footer-admin-link">Panel</a>
        </div>
      </div>
    </footer>
  );
}
